import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { getDonorsFromFolder } from '../../../utils/donorHelpers';
import shared, { dp } from '../../../utils/shared.js';
import NewarkAmbassadorStory from './NewarkAmbassadorStory';
import NewarkDonorLists from './NewarkDonorLists';
import NewarkFullScreenImage from './NewarkFullScreenImage';
import NewarkThankYouMessage from './NewarkThankYouMessage';
import NewarkWelcomeMessage from './NewarkWelcomeMessage';
import NewarkDonorList2 from './NewarkDonorList2';

const DONOR_LIST_BACKGROUND = "donor_list_background";

class NewarkContainer extends Component {

  constructor(props) {
    super(props);
    this._cycles = [];
    this._cycleTimeoutHandler = null;
    this.state = {
      currentIndex: 0
    }
  }

  componentDidMount() {
    let rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    if (rootFolderId !== null && rootFolderId !== undefined) {
      rootFolderId = Number(rootFolderId);
    }
    
    const rootFolder = this.props.content.story_categories.find(f => f.id === rootFolderId);
    this._attractLoopTree = shared.createFolderTree(
      this.props.content.story_categories,
      this.props.content.folder_modules,
      null,
      this.props.content.stories,
      this.props.content.dm_active,
      rootFolder.name,
      'rank'
    );
    const children = this._attractLoopTree.children;
    
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      const cycleTime = _.get(child, 'contents.custom_fields.cycle_timeout.val', 10);
      this._cycles.push(Number(cycleTime));
    }

    this.startAttractLoopCycle();
  }

  componentWillUnmount() {
    clearTimeout(this._cycleTimeoutHandler);
  }

  startAttractLoopCycle = () => {
    clearTimeout(this._cycleTimeoutHandler);
    const cycleTime = this._cycles[this.state.currentIndex];
    const attractLoopChild = this._attractLoopTree.children[this.state.currentIndex];
    const type = _.get(attractLoopChild, 'contents.custom_fields.folder_type.val.value', null);
    if (type !== DONOR_LIST_BACKGROUND) {
      this._cycleTimeoutHandler = setTimeout(() => {
        this.cycle();
      }, cycleTime * 1000);
    }
  }

  cycle = () => {
    this.setState(prevState => ({
      currentIndex: shared.loopIndex(prevState.currentIndex, 0, this._cycles.length - 1, "forward")
    }), () => {
      this.startAttractLoopCycle();
    });
  }

  getSlideshowImageObj = (customFields, attractLoopChild) => {
    const slideshow = Object.keys(customFields)
      .map(fieldName => customFields[fieldName])
      .find(({ type, module }) => type === 'module' && module === 'slideshow');
    
    if (slideshow) {
      const moduleId = _.get(slideshow, 'val.value');
      const slideshowModule = this.props.content.dm_active.find(m => m.id === moduleId && m.display_module_type === 'Slideshow');
      const slideshowIndex = _.get(attractLoopChild, 'contents.custom_fields.background.child_val.value', 0);
      const imageObj = _.get(slideshowModule, `contents.images[${slideshowIndex}]`);
      return dp(this.props.screen, imageObj, { path: '/img/ui/', file_name: 'image_default.png' })
    }
    return null;
  }

  getRenderedContent = () => {
    if (!this._attractLoopTree) {
      return null;
    }

    const attractLoopChild = this._attractLoopTree.children[this.state.currentIndex];
    const customFields = _.get(attractLoopChild, 'contents.custom_fields', {});
    
    if (attractLoopChild.node_type === "folder") {
      // Donor lists
      const useOnlyInnerCycle = this._attractLoopTree.children.length === 1;
      const type = _.get(attractLoopChild, 'contents.custom_fields.folder_type.val.value', null);
      if (type === DONOR_LIST_BACKGROUND) {
        return <NewarkDonorList2
          key={attractLoopChild.id}
          module={attractLoopChild}
          content={this.props.content}
          screen={this.props.screen}
          donors={this.props.donors}
          width={this.props.screen.screenWidth}
          height={this.props.screen.screenHeight}
          cycle={this.cycle}
          useOnlyInnerCycle={useOnlyInnerCycle}
        />
      } else {
        const donorListCategories = this.props.content.story_categories
        .filter(dl => dl.parent_category === attractLoopChild.id)
        .sort((a, b) => {
          return a.rank - b.rank
        });
        const donorLists = donorListCategories.map(donorList => ({
          ...donorList,
          donors: _.orderBy(getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, donorList.id), ['sorting_name'], ['asc'])
        }));
        const title = _.get(customFields, 'title.val');
        const subtitle = _.get(customFields, 'subtitle.val');
        
        return <NewarkDonorLists donorLists={donorLists} title={title} subtitle={subtitle}/>
      }


    } else {      
      // Stories
      const storyType = _.get(customFields, 'story_type.val.value', null);
      const headline = _.get(customFields, 'headline.val');
      const body = _.get(customFields, 'body.val');
      const images = _.get(attractLoopChild, 'contents.images', []).map(image => {
        return dp(this.props.screen, image, { path: '/img/ui/', file_name: 'image_default.png' })
      });

      const bodyOps = _.get(body, 'ops', []);
      const backgroundImage = this.getSlideshowImageObj(customFields, attractLoopChild);
      
      switch(storyType) {
        case "welcome_message":
          return <NewarkWelcomeMessage headline={headline} bodyOps={bodyOps} image={images[0]} backgroundImage={backgroundImage}/>
        
        case "ambassador_story":
          return <NewarkAmbassadorStory headline={headline} bodyOps={bodyOps} image={images[0]} backgroundImage={backgroundImage}/>
        
        case "thank_you_message":
          return <NewarkThankYouMessage image={images[0]} backgroundImage={backgroundImage}/>
        
        case "fullscreen_image":
          return <NewarkFullScreenImage image={images[0]}/>
        
        default:
          return null;
      }
    }
  }

  render() {
    return (      
      <CSSTransitionGroup
        component='div'
        transitionName='slowfadedelay'
        transitionEnterTimeout={0}
        transitionLeaveTimeout={0}>
        <div key={this.state.currentIndex} className="newark__outer-container">
          {this.getRenderedContent()}
        </div>
      </CSSTransitionGroup>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    screen: state.screen,
    donors: state.donors
  };
};

export default connect(mapStateToProps, null)(NewarkContainer);



// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkContainer.js